import { render, staticRenderFns } from "./TasksSection.vue?vue&type=template&id=7aac593a&scoped=true"
import script from "./TasksSection.vue?vue&type=script&lang=js"
export * from "./TasksSection.vue?vue&type=script&lang=js"
import style0 from "./TasksSection.vue?vue&type=style&index=0&id=7aac593a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aac593a",
  null
  
)

export default component.exports